module.exports = __webpack_public_path__ + "static/media/genericPlus.ceee84df.svg";